// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__MFmXH","primaryButton":"button_primaryButton__X5rxB"};